let Summary2000=[
    {"Countryname":" ",
    "OZ":0,
    "ME":195,
    "NU":161,
    "DI":207,
    "HR":230,
    "CO":122,
    "EC":82,
    "OT":0
    }]
export default Summary2000